import { isVoycloudProfileV1015 } from './googleGeminiConfigV816';

export function imageResponsePolicyV103(config = {}) {
  const rawProcessing = config.image_response_processing_v103 || 'passthrough';
  const processing =
    { basic: 'passthrough', full: 'validate' }[rawProcessing] || rawProcessing;
  const formats = config.image_response_formats_v103 || 'unrestricted';
  if (!['passthrough', 'local', 'validate'].includes(processing))
    throw new Error('image_response_v103.invalid_processing');
  if (!['unrestricted', 'both', 'b64_json', 'url'].includes(formats))
    throw new Error('image_response_v103.invalid_formats');
  return { processing, formats };
}

export function channelImageConfigV103(channel) {
  try {
    const config =
      typeof channel.config === 'string'
        ? JSON.parse(channel.config || '{}')
        : channel.config || {};
    if (!config || typeof config !== 'object' || Array.isArray(config))
      throw new Error('image_response_v103.invalid_policy');
    return config;
  } catch {
    throw new Error('image_response_v103.invalid_policy');
  }
}

export function hasNativeImageBridgeV103(type, groups, config) {
  return isVoycloudProfileV1015(type, config);
}
